export default abstract class IdentityObject {
  private static __count = 0;
  public readonly __currentVersion: number;
  constructor() {
    this.__currentVersion = IdentityObject.__count++;
  }

  dispose() {}
}
